import React from "react";

const Section3InformationCollection = () => (
  <>
    <h2>3. Definitions</h2>
    <p>
    For the purposes of these Terms, the following definitions shall apply:
      <ul>
        <li><strong>"Account"</strong> means the unique account created by a User to access and use the Service.</li>
        <li><strong>"Comparedly.com"</strong> or <strong>"Service"</strong> refers to the social media analytics tool provided by Comparedly Ltd., including all related websites, applications, software, and services.</li>
        <li><strong>"Content"</strong> means any data, information, text, graphics, photos, videos, or other material that Users upload, submit, post, display, or otherwise transmit or make available through the Service.</li>
        <li><strong>"Intellectual Property Rights"</strong> means all patents, rights to inventions, copyright and related rights, moral rights, trademarks, service marks, trade names, domain names, rights in get-up, rights to goodwill or to sue for passing off, rights in designs, rights in computer software, database rights, rights in confidential information (including know-how and trade secrets) and any other intellectual property rights, in each case whether registered or unregistered and including all applications for and renewals or extensions of such rights, and all similar or equivalent rights or forms of protection in any part of the world.</li>
        <li><strong>"Subscription Term"</strong> means the period for which a User has subscribed to the Service, as indicated in the applicable subscription plan.</li>
        <li><strong>"User"</strong> or <strong>"you"</strong> refers to any individual or organization that accesses or uses the Service.</li>
        </ul>
    </p>

  </>
);

export default Section3InformationCollection;
